import { ReactNode } from "react";

import {
  SearchResultColumnMetadata,
  SearchResultRow,
} from "../../../features/search/api/search-metadata.types";
import { SearchResultsColumn } from "../../../layout/results-table/ui/search-results-table";
import { formatTableDate } from "../../../shared/lib/format-date";

interface ColumnRenderer {
  // eslint-disable-next-line no-unused-vars
  body(row: SearchResultRow, field: string): ReactNode;
  // eslint-disable-next-line no-unused-vars
  sortValue?(row: SearchResultRow, field: string): string | number | null;
}

/** Cell renderers the backend can reference by `rendererId`. */
const COLUMN_RENDERERS: Record<string, ColumnRenderer> = {
  // mm/dd/yyyy output, chronological sorting
  date: {
    body: (row, field) =>
      formatTableDate(row[field] as string | number | Date | null),
    sortValue: (row, field) => {
      const value = row[field];
      if (!value) return null;
      const time = new Date(value as string).getTime();
      return Number.isNaN(time) ? String(value) : time;
    },
  },
  // em-dash for empty values
  dash: {
    body: (row, field) => (row[field] as ReactNode) || "—",
  },
};

export const buildTableColumns = (
  columns: SearchResultColumnMetadata[],
): SearchResultsColumn<SearchResultRow>[] =>
  columns.map((column) => {
    const renderer = column.rendererId
      ? COLUMN_RENDERERS[column.rendererId]
      : undefined;

    return {
      field: column.field,
      header: column.header,
      body: renderer ? (row) => renderer.body(row, column.field) : undefined,
      sortValue: renderer?.sortValue
        ? (row) => renderer.sortValue!(row, column.field)
        : undefined,
    };
  });
